// extracted by mini-css-extract-plugin
module.exports = {"code":"PrototypePollution_code__Y_Ck1"};